export default __webpack_public_path__ + "static/media/alarm-svgrepo-com-white.7b777ab6.svg";